var _style, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 321.7 321.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#d8d8da}.st1{fill:#262127}.st2{fill:#dd8787;stroke:#262127;stroke-width:3;stroke-miterlimit:10}.st3{fill:#ebb0a0}")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-77.837 145.885 165.075)",
    className: "st0",
    cx: 145.9,
    cy: 165.1,
    rx: 13,
    ry: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.3 135.5c0-.1-1.2-.3-1.3-.3-3.2-.7-6.5-1.2-9.9-1.2-3.3-.1-6.6.4-9.8 1.1-.5.1-.9.2-1.4.3-.2 0-.4.1-.6.1 0 0-2.6 8.2 1.3 5.6 1.8-1.2 3.9-1.6 6-1.8 2.8-.3 5.5-.2 8.3 0 2.1.1 4.4.6 6.2 1.8 3.8 2.6 1.2-5.6 1.2-5.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.4 166c1.5 7 4.7 12.2 7.1 11.7 2.4-.5 3.1-6.6 1.6-13.6s-4.7-12.2-7.1-11.7c-2.4.5-3.1 6.6-1.6 13.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.3 127.3c2.6-1.8 40.1-5.5 53.6-5.1 13.5.4 39.6 5.7 45.5 11.1 5.9 5.4 2.3 13.5-1.4 16.7-3.6 3.3-83.5 2.1-83.5 2.1l-6.6.2s.6-5.7-1.5-8.1c-2-2.4-5.5-3.2-6.3-5.8-.5-2.7.2-11.1.2-11.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.6 135.5c6.9-8.8 28.3-8.9 38.5-8.2 10.2.6 26.8 1.8 34.8 12.1 8 10.4 7 32.7-3.3 44.2-10.4 11.5-21.6 16.8-35.7 15.7-14.1-1.1-27.8-6.7-34.2-22.6s-6.8-32.7-.1-41.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.8 161.5c.7 4.9 2.1 9.9 4.1 14.9 6.2 15.6 19.4 21.1 33 22.2 13.5 1.1 24.4-4.2 34.4-15.4 4.9-5.5 7.6-13.6 8.2-21.6H64.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.3 127.3c-2.6-1.8-40.1-5.5-53.6-5.1-13.5.4-39.6 5.7-45.5 11.1-5.9 5.4-2.3 13.5 1.4 16.7 3.6 3.3 83.5 2.1 83.5 2.1l6.6.2s-.6-5.7 1.5-8.1c2-2.4 5.5-3.2 6.3-5.8.6-2.7-.2-11.1-.2-11.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M254.1 135.5c-6.9-8.8-28.3-8.9-38.5-8.2-10.2.6-26.8 1.8-34.8 12.1-8 10.4-7 32.7 3.3 44.2 10.4 11.5 21.6 16.8 35.7 15.7 14.1-1.1 27.8-6.7 34.2-22.6 6.6-15.8 6.8-32.7.1-41.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.8 161.5c-.7 4.9-2.1 9.9-4.1 14.9-6.2 15.6-19.4 21.1-33 22.2-13.5 1.1-24.4-4.2-34.4-15.4-4.9-5.5-7.6-13.6-8.2-21.6h79.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/21.0bbbddfe0834cf2f52edce39b77a3b14.svg";
export { ForwardRef as ReactComponent };